<template>
    <div class="mt-8 flex flex-col gap-4 ml-12 h-[calc(100vh-100px)] text-justify" :class="showRightMargin && 'mr-12'">
        <div class="flex flex-col gap-3">
          <div class="text-pohvDark font-bold text-xl">{{ title }}</div>
          <div v-if="description" class="text-sm font-bold">{{ description }}</div>
        </div>
        <slot />
        <div class="flex-1"></div>
        <div class="flex">
          <slot name="leftButton">
            <div class="flex-1">
              <BlueButton v-if="showLeftButton || showLeftButton == undefined" mode="arrowLeft" @click="navigateBack" :class="leftButtonClasses" />
            </div>
          </slot>
          <slot name="rightButton">
            <BlueButton v-if="showRightButton || showRightButton == undefined" mode="arrowRight" @click="navigateForward" :class="rightButtonClasses" />
          </slot>
        </div>
    </div>
</template>
<script lang="ts" setup>
interface Props {
  title?: string,
  description?: string,
  rightButtonClasses?: string,
  leftButtonClasses?: string,
  showLeftButton?: boolean,
  showRightButton?: boolean,
  showRightMargin?: boolean,
  valid?: boolean
}

import BlueButton from '@/components/BlueButton.vue';
const props = withDefaults(defineProps<Props>(), {
  showRightMargin: true,
  showRightButton: true,
  showLeftButton: true
})

const emit = defineEmits(['navigateBack', 'navigateForward', 'showError'])

function navigateBack() {
  emit('navigateBack')
}

function navigateForward() {
  if (!props.valid) {
    showError()
  } else {
    emit('navigateForward')
  }
}

function showError() {
  emit('showError')
}
</script>
